import React from 'react'
import styles from './Cta.module.css'
import Button from '@mui/material/Button';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
// import { Link } from 'react-router-dom';


const Cta = () => {
  return (
    <section className={styles.cta_area}>
        <div className={styles.btn_wrapper}>
            <div>お問い合わせはこちら</div>
            <div>
                <Button variant="outlined" endIcon={<ArrowRightAltIcon fontSize="large"/>} as="a" href="https://cellnology.jp/3daylp/001/contact.php">
                    Contact
                </Button>
            </div>
        </div>
        <div className={styles.btn_wrapper}>
            <div>カレンダーより直接予約</div>
            <div>
                <Button variant="outlined" endIcon={<ArrowRightAltIcon fontSize="large"/>} as="a" href="https://timerex.net/s/cell-3dayslp/d5b0e773">
                    Reserve
                </Button>
            </div>
        </div>
    </section>
  )
}

export default Cta